export default "__VITE_ASSET__PfXa8j7d__"